module.exports = __webpack_public_path__ + "static/img/logistics1.eb464ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/logistics1.png?v=1
// module id = DGrY
// module chunks = 1